import React from "react"
import { Button } from "@quorumus/plum"
import { Banner, IconWrap, Content, Actions } from "./NextElectionInfo.styles"

/**
 * UI-only banner to surface next election information.
 * - Buttons are visible but intentionally non-functional (no click handlers)
 * - Values provided via props to allow host page to control content
 */
export type NextElectionInfoProps = {
    electionName: string
    electionDate: string
}

export const NextElectionInfo: React.FC<NextElectionInfoProps> = ({ electionName, electionDate }) => {
    return (
        <Banner data-cy="gotv-next-election">
            <IconWrap aria-hidden="true">
                <i className="fa fa-calendar" />
            </IconWrap>

            <Content>
                <div className="name" data-cy="election-name">
                    {electionName}
                </div>
                <div className="date" data-cy="election-date">
                    {electionDate}
                </div>
            </Content>

            <Actions>
                <Button
                    variant="secondary"
                    size="lg"
                    leftSection={<i className="fa fa-plus" aria-hidden="true"></i>}
                    data-cy="btn-add-to-calendar"
                >
                    Add to calendar
                </Button>
                <Button
                    variant="secondary"
                    size="lg"
                    leftSection={<i className="fa fa-download" aria-hidden="true"></i>}
                    data-cy="btn-download-ics"
                >
                    Download (.ICS)
                </Button>
            </Actions>
        </Banner>
    )
}
